import { JitsiTrackErrors } from '../lib-jitsi-meet';
// DOMException names raised by getUserMedia that we want to preserve verbatim
// in telemetry so a future Production camera failure can be distinguished
// (device busy/unreadable vs permission denied vs missing device vs constraint
// failure). These are browser/OS-level names, not lib-jitsi-meet track errors.
const PRESERVED_DOM_EXCEPTION_NAMES = new Set([
    'NotReadableError',
    'OverconstrainedError',
    'NotFoundError',
    'AbortError',
    'InvalidStateError'
]);
/**
 * Keep a recognized device-error code without retaining vendor text or arbitrary payloads.
 *
 * @param {unknown} error - Browser or SDK media rejection.
 * @returns {string} Safe recognized error name.
 */
export function getMediaErrorName(error) {
    // A JitsiTrackError wraps the original getUserMedia rejection and keeps the
    // raw DOMException in `gum.error` while normalizing its own `name` (e.g. a
    // NotReadableError becomes JitsiTrackErrors.GENERAL). Prefer the raw name so
    // the transient device-release race is not collapsed into "general".
    const name = error && typeof error === 'object' && 'name' in error ? error.name : undefined;
    const gum = error && typeof error === 'object' && 'gum' in error ? error.gum : undefined;
    const cause = gum && typeof gum === 'object' && 'error' in gum ? gum.error : undefined;
    const rawName = cause && typeof cause === 'object' && 'name' in cause ? cause.name : undefined;
    for (const candidate of [rawName, name]) {
        if (candidate === 'SecurityError' || candidate === 'NotAllowedError'
            || candidate === 'PermissionDeniedError') {
            return JitsiTrackErrors.PERMISSION_DENIED;
        }
        if (typeof candidate === 'string'
            && (PRESERVED_DOM_EXCEPTION_NAMES.has(candidate)
                || Object.values(JitsiTrackErrors).includes(candidate))) {
            return candidate;
        }
    }
    return JitsiTrackErrors.GENERAL;
}
